import React, { Component } from "react";
import GenericBankAccountStatements from "./statement";
import { ArrowRightOutlined } from "@ant-design/icons";

class BankAccountStatements extends Component {

    render() {
        return (
            <>
                {(this.props.bankAccountSource && this.props.bankAccountInfo.status !== "Closed" ) ? (
                        <GenericBankAccountStatements
                            bankAccountId={this.props.bankAccountId}
                            bankAccountInfo={this.props.bankAccountInfo}
                            hasStatements={this.props.hasStatements}
                            bankAccountSource={this.props.bankAccountSource}
                        />
                ) : (
                    <span style={{
                        fontWeight: "600",
                        fontSize: "14px",
                        color: "rgba(0,0,0,0.25)",
                    }}>
                        View Statement <ArrowRightOutlined />
                    </span>
                  )
                }
            </>
        );
    }
}

export default BankAccountStatements;
